import DOMPurify from 'dompurify';

const richTextTags = /<\/?(?:a|b|br|em|i|li|ol|p|small|strong|u|ul)\b/i;

export function sanitiseRichText(value: string): string {
  const normalised = value.replace(/\\n/g, '\n');
  const source = richTextTags.test(normalised) ? normalised : escapeHtml(normalised);
  return DOMPurify.sanitize(source.replace(/\n/g, '<br>'), {
    ALLOWED_TAGS: ['a', 'b', 'br', 'em', 'i', 'li', 'ol', 'p', 'small', 'strong', 'u', 'ul'],
    ALLOWED_ATTR: ['href', 'rel', 'target'],
  });
}

function escapeHtml(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}
